const firebaseConfig = {
    apiKey: "AIzaSyDhYxyu1xYEGlOQgdaiwu3VIfGeeHW7XGw",
    authDomain: "ludimationof-c6287.firebaseapp.com",
    projectId: "ludimationof-c6287",
    storageBucket: "ludimationof-c6287.appspot.com",
    messagingSenderId: "1029788755516",
    appId: "1:1029788755516:web:4c6eadc08ced1c1f1a4539"
}

export default firebaseConfig